<template>
    <v-container fill-height justify-center align-center>
        <v-layout row>
            <v-flex>
                <v-container fill-height justify-center align-center>
                    <v-flex xs12 md4>
                        <v-card class="mt-0 pt-0">
                            <v-card-title class="primary darken-1 white--text">
                                <img src="@/assets/logo.png" alt="Campi Asesores" style="max-height: 70px">
                                <h4 class="headline"><span class="ml-2" style="font-family: 'Crimson Text';font-weight: 600">ASESORES EN SEGUROS</span></h4>
                            </v-card-title>
                            <v-card-text>
                                <p>Ingrese sus datos para iniciar sesión</p>
                                <form @submit.prevent="login">
                                    <v-layout row wrap>
                                        <v-flex xs12>
                                            <v-text-field ref="username" required
                                                          type="text"
                                                          append-icon="mail" name="Username" v-model="username"
                                                          label="Usuario" value="Input text"></v-text-field>
                                        </v-flex>
                                    </v-layout>
                                    <v-layout row wrap>
                                        <v-flex xs12>
                                            <v-text-field required
                                                          append-icon="lock"
                                                          name="password" type="password" v-model="password"
                                                          label="Clave" value="Input text"></v-text-field>
                                        </v-flex>
                                    </v-layout>
                                    <v-layout row wrap>
                                        <v-flex xs12 class="text-xs-right">
                                            <v-btn type="button" buscolor="secondary"
                                                   :disabled="loading"
                                                   :loading="loading" @click="goHome">Ir al Inicio
                                            </v-btn>
                                            <v-btn type="submit" buscolor="primary"
                                                   :disabled="loading || !validated"
                                                   :loading="loading">Entrar
                                            </v-btn>
                                        </v-flex>
                                    </v-layout>

                                    <v-snackbar color="error" error v-if="error" :timeout="timeout" :top="true"
                                                v-model="error">
                                        {{ text }}
                                        <v-btn secondary flat @click.native="error = false">Cerrar</v-btn>
                                    </v-snackbar>
                                </form>
                            </v-card-text>
                        </v-card>
                    </v-flex>
                </v-container>
            </v-flex>
        </v-layout>
        <app-footer/>
    </v-container>
</template>

<script>
  import AppFooter from '@/components/Common/Footer'
  import router from '@/router'
  import qs from 'qs'

  export default {
    name: 'Login',
    data () {
      return {
        error: false,
        text: '',
        mode: 'vertical',
        timeout: 3000,
        username: '',
        password: ''
      }
    },
    computed: {
      loading () {
        return this.$store.getters['user/loading']
      },
      validated () {
        if (this.username && this.password) {
          return true
        }
      }
    },
    mounted () {
      this.$refs.username.focus()
    },
    methods: {
      login () {
        this.$store.dispatch('user/setLoading', true)
        this.axios.post('auth', qs.stringify({
          username: this.username,
          password: this.password
        })).then(
          response => {
            const payload = {
              user: response.data,
              token: response.data.token
            }
            this.$store.dispatch('user/updateUser', payload)
            this.$store.dispatch('user/setLoading', false)
          }
        ).catch(
          error => {
            this.$store.dispatch('user/setLoading', false)
            this.error = true
            if (error.response && error.response.status === 401) {
              this.text = 'Usuario o clave inválidos'
            } else {
              this.text = 'Error al tratar de entrar'
            }
          }
        )
      },
      goHome () {
        router.push('inicio')
      }
    },
    components: {
      AppFooter
    }
  }
</script>

<style scoped>

</style>


// WEBPACK FOOTER //
// src/components/User/Login.vue